import React, { Component } from "react";
import { connect } from "react-redux";
import * as userActions from "../../../_actions/userActions";
import * as appActions from "../../../_actions/appActions";
import Input from "../../UI/Input";
import Wrapper from "../../../_hoc/Wrapper";
import Button from "../../UI/Button";
import getMyEmailInfo from "../../../_selectors/userSelectors/getMyEmailInfo";
import { isEmpty } from "lodash";

class ResetPassword extends Component {
  state = {
    password: "",
    showReset: false,
    error: undefined,
    resetPassword: "",
    repeatPassword: ""
  };
  authenticate = () => {
    const { authenticate, email } = this.props;
    const { password } = this.state;

    const onSuccess = () => {
      this.setState({ showReset: true, error: undefined });
    };
    const onError = err => {
      this.setState({
        password: "",
        showReset: false,
        error: "Invalid Password"
      });
    };
    authenticate({ email, password, onSuccess, onError });
  };
  reset = () => {
    const { resetPassword, repeatPassword } = this.state;
    const { reset, onClose, toast } = this.props;
    if (resetPassword === repeatPassword) {
      //do nothing
      const onSuccess = () => {
        onClose();
        toast({ type: "info", message: "Password Updated!" });
      };
      const onError = err => {
        this.setState({
          error: "Try Another Password"
        });
      };
      reset({ password: resetPassword, onSuccess, onError });
    } else {
      this.setState({ error: "Password does not match" });
    }
  };

  render() {
    const {
      error,
      password,
      showReset,
      resetPassword,
      repeatPassword
    } = this.state;
    if (showReset) {
      return (
        <Wrapper>
          <h2 className="text-center">Reset Password</h2>
          <form
            onSubmit={event => {
              event.preventDefault();
              this.reset();
            }}
          >
            <div className="form-group-one-unit">
              <div className="row">
                <div className="col-sm-12">
                  <Input
                    value={resetPassword}
                    onChange={value => {
                      this.setState({ resetPassword: value, error: undefined });
                    }}
                    label={<Wrapper>New Password</Wrapper>}
                    type="password"
                  />
                </div>
                <div className="col-sm-12">
                  <Input
                    value={repeatPassword}
                    onChange={value => {
                      this.setState({
                        repeatPassword: value,
                        error: undefined
                      });
                    }}
                    label={<Wrapper>Enter Password Again</Wrapper>}
                    info={error}
                    type="password"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <Button
                  label="Change"
                  style={{
                    display: "block",
                    margin: "0 auto",
                    marginTop: "10px"
                  }}
                  className="pull-right"
                  primary
                  small
                  clean
                  disabled={
                    isEmpty(resetPassword) || isEmpty(repeatPassword)
                      ? true
                      : false
                  }
                  onClick={this.reset}
                />
              </div>
            </div>
          </form>
        </Wrapper>
      );
    } else {
      return (
        <Wrapper>
          <h2 className="text-center">Current Password</h2>
          <form
            onSubmit={event => {
              event.preventDefault();
              this.authenticate();
            }}
          >
            <div className="form-group-one-unit">
              <div className="row">
                <div className="col-sm-12">
                  <Input
                    value={password}
                    onChange={value => {
                      this.setState({ password: value, error: undefined });
                    }}
                    label={<Wrapper>Current Password</Wrapper>}
                    info={error}
                    type="password"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <Button
                  label="Continue"
                  style={{
                    display: "block",
                    margin: "0 auto",
                    marginTop: "10px"
                  }}
                  type="submit"
                  className="pull-right"
                  primary
                  small
                  clean
                  onClick={this.authenticate}
                />
              </div>
            </div>
          </form>
        </Wrapper>
      );
    }
  }
}
const mapStateToProps = (state, ownProps) => ({
  email: getMyEmailInfo(state)
});
const mapDispatchToProps = dispatch => ({
  authenticate: payload => dispatch(userActions.reAuthenticateUser(payload)),
  reset: payload => dispatch(userActions.resetPassword(payload)),
  toast: payload => dispatch(appActions.showToast(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/_components/Settings/ResetPassword/index.js